export enum BusinessUserStatus{
    UNKNOWN,
    ACTIVE,
    INVITED,
    DEACTIVATED,
    INVITECLAIMED
}